import I18n from "i18n-js";
import React from "react"

class SurveyFormsDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.row.survey_forms && this.props.row.survey_forms.length > 0) {
      var forms = this.props.row.survey_forms.map((form)=>{
        return <li key={form.id}>{`${form.title}`}</li>  
      })
      return (
        <ul className="RoomTypesDataType">{forms}</ul>
      );
    } else {
      return I18n.t("none");
    }
  }

};

export default SurveyFormsDataType